import LoyaltyTermsConditionsLinkContainer from './LoyaltyTermsConditionsLinkContainer';

export default LoyaltyTermsConditionsLinkContainer;
